import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[appNoScrollNumber]',
  standalone: false,
})
export class NumberInputNoScrollDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {
    if (document.activeElement === this.el.nativeElement) {
      event.preventDefault();
    }
  }
}
